export const bookingUrl = 'https://calendly.com/earlyedgecoaching/30min';
export const brand = {
  name: 'Early Edge Coaching',
  tagline: 'FIND YOUR EDGE',
  email: 'hello@earlyedgecoaching.com',
  phone: '(415) 555-0134'
};
export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/919e9e9d-891f-4274-a62f-d8d7ea2f7a34.jpg',
  coach: 'https://cdn.magicpatterns.com/patterns/generated-images/bd104e8c-4333-40e8-a074-66655ff7b274.jpg',
  session: 'https://cdn.magicpatterns.com/patterns/generated-images/f37a9ae1-61dd-4553-a977-4b8bea461dac.jpg'
};
export type ReelClip = {
  id: string;
  src: string;
  caption: string;
  likes: string;
  alt: string;
};
export const reelClips: ReelClip[] = [{
  id: 'tedx',
  src: 'https://cdn.magicpatterns.com/uploads/4FeDxUfYQQjivSXuxzAyVK/IMG_5976.jpg',
  caption: 'My high school attempt at a Tedx speech!',
  likes: '2,481',
  alt: 'A high school student speaking from a podium in a classroom'
}, {
  id: 'recruiter',
  src: 'https://cdn.magicpatterns.com/uploads/2x7xGFG3s97xhjqqtKqjyx/IMG_5967_2.jpg',
  caption: 'My first day as a campus recruiter',
  likes: '3,046',
  alt: 'Laughing in a blazer, dressed for a first day as a campus recruiter'
}, {
  id: 'founded',
  src: 'https://cdn.magicpatterns.com/uploads/8A6ZYijHNAzDBEmjmuw5wu/processed-E77BE487-F7E8-4B89-8CCE-0A91C7ADA433.jpg',
  caption: 'Found my corporate stride and founded Early Edge Coaching',
  likes: '4,112',
  alt: 'Portrait of the founder of Early Edge Coaching outdoors'
}];
export const navLinks = [{
  label: 'Coaching',
  href: '#coaching'
}, {
  label: 'Packages',
  href: '#pricing'
}, {
  label: 'For parents',
  href: '#for-parents'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export const heroStats = [{
  value: 'Class & Work Presentations',
  label: ''
}, {
  value: 'College & Job Interviews',
  label: ''
}, {
  value: 'Professional Etiquette',
  label: ''
}];
export const addOns = [{
  name: "Job or internship interviews",
  detail: 'Turnaround in 3 business days.'
}, {
  name: "Class or work presentations",
  detail: 'Two recorded rounds with scored feedback.'
}, {
  name: "Virtual communication",
  detail: 'Timeline, essays, and decision support.'
}, {
  name: "Networking and outreach",
  detail: 'Scripts and a plan for cold messages.'
}, {
  name: "Professional etiquette",
  detail: 'Email, meetings, and first-week norms.'
}, {
  name: "Personal brand",
  detail: 'Practice rounds with direct feedback.'
}];
export type Path = {
  id: string;
  label: string;
  chip: string;
  headline: string;
  blurb: string;
};
export const paths: Path[] = [{
  id: 'freeze',
  label: 'I freeze up',
  chip: 'I freeze up',
  headline: 'first career move',
  blurb: "The second you're ready to answer a question, everything you rehearsed disappears. We train the exact moment your brain goes blank. After coaching, you'll be ready to answer every question—ask them."
}, {
  id: 'presenting',
  label: 'I dread presenting',
  chip: 'I dread presenting',
  headline: 'internship offer',
  blurb: 'The dry mouth, the racing heart, the sweaty armpits. We get it. A few real reps with someone watching changes more than scrolling through a hundred videos ever will.'
}, {
  id: 'confidence',
  label: "I don't feel confident",
  chip: "I don't feel confident",
  headline: 'first real job',
  blurb: "You know you're capable. You might just not feel or sound like it yet. We build the kind of confidence that actually holds you up when it counts."
}, {
  id: 'story',
  label: 'I want to find my story',
  chip: 'I want to find my story',
  headline: 'personal brand',
  blurb: "You have a voice and a story. We'll help you learn how to tell it so no one forgets you, or your impact."
}];
export const parentPoints = [{
  title: 'Flat, transparent pricing',
  description: 'All package costs are shared on the initial consultation call. Once a preferred package has been selected, the final agreement will reflect all costs. There are never hidden fees.'
}, {
  title: 'Vetted, credentialed coaches',
  description: 'Emberly is background-checked and has recruited, hired, and managed early career talent.'
}, {
  title: 'You stay in the loop',
  description: 'Optional monthly progress summaries by email. Your student sets what gets shared — we keep it honest either way.'
}, {
  title: 'Results we will stand behind',
  description: '92% of Launch students report at least one interview within 8 weeks. If the first session is not useful, it is free.'
}];
export const faqs = [{
  question: 'Is coaching in-person or virtual?',
  answer: 'Early Edge Coaching is owned and operated in Austin, TX. In-person coaching is available in the Austin area. All other locations receive virtual coaching support. Virtual coaching can be requested for Austin area clients.'
}, {
  question: 'What does a package cost?',
  answer: 'All pricing is discussed on the initial consultation call. We pride ourselves on providing a fair pricing structure that allows students to access coaching support.'
}, {
  question: 'Can we change or cancel a package?',
  answer: 'Yes. Reschedule any session with 24 hours notice, and pause or cancel a package at any time. Unused sessions are refunded in full.'
}];